// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class LocationCityModels {
    static getAttributeTypeMap() {
        return LocationCityModels.attributeTypeMap;
    }
}
LocationCityModels.discriminator = undefined;
LocationCityModels.additionalProperties = false;
LocationCityModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=locationCityModels.js.map